import { render, staticRenderFns } from "./UserPaymentPlansList.vue?vue&type=template&id=6c2462aa&scoped=true&"
import script from "./UserPaymentPlansList.vue?vue&type=script&lang=js&"
export * from "./UserPaymentPlansList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2462aa",
  null
  
)

export default component.exports